<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_vi"></a><em>To my parents, Watson and Jenny,<br/>who first sowed the seed and to<br/>Erica, Simone, Jonathan and Scout,<br/>whose unconditional love<br/>helped nurture it</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?6510d5aa